var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: _vm.$style.PageHeading
  }, [_c('h2', {
    class: _vm.$style.heading
  }, [_vm.$slots.text ? [_vm._t("text")] : [_vm._v("\n      " + _vm._s(_vm.text) + "\n    ")]], 2)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };